<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_4"><span>Acknowledgments</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent"><span style=" font-size: 0.93em;">AS ALWAYS,</span> a huge thank you to my beta team, and to Jason Mitchell for always being there.</p>
<p class="P_Normal">With special thanks to Wulf Francú Godgluck for all the video calls and messages where we picked his brains. He came up with so much information, and it helped enormously.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?74b5b1ab